/** `/math` typed at the caret in a variable value field. */
export const MATH_SLASH_RE = /\/math$/i;

/** In-progress `/` … `/math` in an empty number field. */
export const MATH_SLASH_DRAFT_RE = /^\/m?a?t?h?$/i;

export const hasMathSlash = (text) =>
  MATH_SLASH_RE.test(String(text || '').replace(/\u00a0/g, ' '));

export const stripMathSlash = (text) =>
  String(text || '')
    .replace(/\u00a0/g, ' ')
    .replace(MATH_SLASH_RE, '');

export const isMathSlashDraft = (text) =>
  MATH_SLASH_DRAFT_RE.test(String(text || '').trim());
